import React, { Component, createRef } from "react";
import InputField from './input';
import ButtonField from './button';
import InputSelect from './select';
import Switch from './switch';
import InputDate from './date';
import '../../SCSS/input.scss';
import Button from '@material-ui/core/Button';
import InputRadio from './radio';
import InputCheckbox from './checkbox';
import InputTextArea from './text';
import Axios from 'axios';
import { Alert } from 'rsuite';
// import HistoryIcon from '../../assets/icons/history-icon.svg';
import Checkbox from "@material-ui/core/Checkbox";
import TextField from '@material-ui/core/TextField';
import "../../SCSS/common-table.scss";
class ZenForm extends Component {
    constructor() {
        super();
        this.state = {
            formData: [],
            formClass: undefined,
            formHeading: undefined,
            submitCheck: false,
            env: JSON.parse(localStorage.getItem('env')),
            clear: false,
            libraryData: {}
        };
        this.formRef = React.createRef();
    }
    componentDidMount() {
        this.setState({ formData: this.props.inputData, formClass: "", formHeading: "", clear: this.props.clear == undefined ? false : this.props.clear })

    }
    onSubmit = async (e) => {
        e.preventDefault();
        // console.log('***e***', e.target.elements.password.value)
        // console.log('***e***', e.target.elements.confirmPassword.value)
        let formElts = e.target.elements
        // console.log('***e***', e.target.elements.email.value)
        // console.log('***this***', this)
        if (String(window.location.href).includes('login') || String(window.location.href) == "http://3.6.111.111:3000/#/") {
            if (localStorage.getItem('channel') == undefined) {
                localStorage.setItem('channel', e.target.elements.email.value)
            }
        }
        // if (!this.state.submitCheck) {
        let fd = this.state.formData
        let submitCheck = false
        if (this.state.env['type'] === 'passive') {
            // var recptResp = (String(window.location.href).includes('login') || String(window.location.href).includes('register') || String(window.location.href) == "http://3.6.111.111:3000/#/") ?
            //     await Axios.get(`${this.state.env['automationUri']}/34xfyEFCT914faghsrH35?contact=${localStorage.getItem('channel')}`) :
            //     { data: { Automation: "false" } }
            var recptResp = { data: { Automation: "false" } }
            fd.map(item => {
                if (item.required && item.requiredBoolean && item.category != 'button') {
                    if (item.category == "recaptcha") {
                        console.log(recptResp)
                        // .then(resp => {
                        if (recptResp.data.Automation == "true") {
                            submitCheck = submitCheck
                        } else {

                            if (!item.validation) {
                                submitCheck = true
                                item['error'] = true
                                item['errorMsg'] = `Invalid ${item.label}`
                            } else {
                                submitCheck = submitCheck
                                item['error'] = false
                            }
                        }
                        // })
                        // .catch(err => {
                        // })

                    } else if (item.name == 'confirmPassword') {

                        if (e.target.elements.password.value === e.target.elements.confirmPassword.value) {
                            submitCheck = submitCheck
                            item['error'] = false
                        }
                        else {
                            submitCheck = true
                            item['error'] = true
                            item['errorMsg'] = 'Passwords not match'
                        }
                    } else {

                        if (!item.validation) {
                            submitCheck = true
                            item['error'] = true
                            item['errorMsg'] = `Invalid ${item.label}`
                        } else {
                            submitCheck = submitCheck
                            item['error'] = false
                        }
                    }
                }
                // if (item.type == 'submit') {
                //     this.props.onSubmit(e.target.elements, item)
                // }
            })

        } else {
            fd.map(item => {
                if (item.required && item.category != 'button') {

                    if (!item.validation) {
                        submitCheck = true
                        item['error'] = true
                        item['errorMsg'] = `Invalid ${item.label}`
                    } else {
                        submitCheck = submitCheck
                        item['error'] = false
                    }
                }
                if (item.name == 'confirmPassword') {

                    if (e.target.elements.password.value === e.target.elements.confirmPassword.value) {
                        submitCheck = submitCheck
                        item['error'] = false
                    }
                    else {
                        submitCheck = true
                        item['error'] = true
                        item['errorMsg'] = 'Passwords not match'
                    }
                }
                // if (item.type == 'submit') {
                //     this.props.onSubmit(e.target.elements, item)
                // }
            })
        }
        this.setState({ submitCheck: submitCheck, formData: fd }, () => {
            if (!this.state.submitCheck) {
                let format = ""
                fd.map(item => {
                    if (item.type == "emailph") {
                        format = item.format
                    }
                    if (item.type == 'submit') {
                        this.props.onSubmit(formElts, item, this.state.formData, format)
                    }
                })
            } else {
                // Alert.error("Please check your data!")
            }
        })
        // }
    }
    onInputChanges = (value, item, event, dataS) => {
        // this.props.onInputChanges(value, item, event, dataS)
        if (this.props.onInputChanges != undefined) {
            if (dataS != undefined) {
                dataS['error'] = false
            } else {
                if (item != undefined) {
                    item['error'] = false
                }
            }
            this.props.onInputChanges(value, item, event, dataS)
        }

        // let submitCheck = false
        // this.setState({ formData: this.state.formData }, () => {
        //     let fd = this.state.formData
        //     fd.map(item => {
        //         if (item.required) {
        //             if (!item.validation) {
        //                 submitCheck = true
        //             } else {
        //                 submitCheck = submitCheck
        //             }
        //         }
        //     })
        //     fd.map(item => {
        //         if (item.type == 'submit' && !submitCheck) {
        //             item['class'] = item['class'].replace('disabled-btn', '')
        //         } else if (item.type == 'submit' && submitCheck) {
        //             if (item['class'].includes("disabled-btn")) {
        //                 item['class'] = item['class']
        //             } else {
        //                 item['class'] = item['class'] + ' ' + 'disabled-btn'
        //             }
        //         }
        //     })
        //     this.setState({ formData: this.state.formData }, () => {
        //         this.setState({ submitCheck: submitCheck })
        //     })
        // })
    }
    onFormBtnEvent = (item) => {
        console.log('check')
        this.props.onFormBtnEvent(item)
    }
    onClearForm = (formDatas) => {
        console.log('***Form Datas***', formDatas)
        formDatas.forEach(task => {
            if (task.clear == undefined) {
                delete task['defaultValue']
                task['required'] = task['requiredBoolean']
                task['validation'] = false
                task['error'] = false
            }
        })
        this.setState({ formData: [] }, () => {
            this.setState({ formData: formDatas })
        })
        // this.props.onClearForm(formDatas)
    }
    onTrAction = (type, item) => {
        if (this.props.onTrAction != undefined) {
            this.props.onTrAction(type, item)
        }
    }
    handleLibraryData = (e, name, item) => {
        //console.log("e", e.target.value)
        let libraryData = this.state.libraryData;
        libraryData[name] = e.target.value;
        this.setState({ libraryData }, () => {
            if (this.props.handleLibraryData != undefined) {
                this.props.handleLibraryData(this.state.libraryData, item)
            }
        })

    }


    formatCurrency = (amount) => {
        return (new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount))
    }


    render() {

        return (
            <React.Fragment>
                {/* <React.Fragment>
                <div className="history-icon-box" title="View History" style={{ width: '8%', marginTop: '10px', display: 'flex',justifyContent:'space-evenly' }} onClick={this.showHistory}> <img src={HistoryIcon} /><p style={{ padding: '0px', paddingLeft: '0px', paddingTop: '3px' }}>Change History</p></div>
                <button onClick={() => this.resetform()}>CLEAR</button>
                </React.Fragment> */}
                {this.state.formData.length > 0 ? <form noValidate ref={this.formRef} className={this.props.formClass} onSubmit={(e) => this.onSubmit(e)}>
                    {this.state.clear ? <Button variant="contained" type="clear" class="secondary-btn form-clear-btn organi-clr-btn" onClick={() => this.onClearForm(this.state.formData)}>Clear</Button> : null}

                    {this.state.formData.map((item, index) => {
                        if (item.category == 'input') {
                            return <InputField inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} onTrAction={this.onTrAction} />
                        }
                        if (item.type == 'select') {
                            return <InputSelect inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        }
                        if (item.type == 'switch') {
                            return <Switch inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        }
                        if (item.type == 'date') {
                            return <InputDate inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        }
                        if (item.category == 'radio') {
                            return <InputRadio inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        }
                        if (item.category == 'checkbox') {
                            return <InputCheckbox inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        }
                        if (item.category == "textarea") {
                            return <InputTextArea inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        }
                        if (item.type == "heading") {
                            return <p className={item.class}>{item.label}</p>
                        }
                        // if (item.type == "cvText") {
                        //     return <div class="table-wrapper clear-both">
                        //         <div className="relieve-question">
                        //             <div className="relieve-question2">
                        //                 1) Is there any particular event or reason that forced you to leave this job?
                        //             </div>
                        //             <div className="relieve-question2">
                        //                 <textarea
                        //                     autoFocus
                        //                     className="input-wrap width-30 margin0 textarea-relieve exit-wrap"
                        //                     id="filled-multiline-static"
                        //                     rows={4}
                        //                     variant="filled"
                        //                     label="Description"
                        //                     defaultValue=""
                        //                     onChange={this.textareaOnchange}
                        //                 />
                        //             </div>
                        //         </div>
                        //         <div className="relieve-question">
                        //             <div className="relieve-question2">
                        //                 2) What do you think about our management process?
                        //             </div>
                        //             <div className="relieve-question2">
                        //                 <textarea
                        //                     autoFocus
                        //                     className="input-wrap width-30 margin0 textarea-relieve exit-wrap"
                        //                     id="filled-multiline-static"
                        //                     rows={4}
                        //                     variant="filled"
                        //                     label="Description"
                        //                     defaultValue=""
                        //                     onChange={this.textareaOnchange}
                        //                 />
                        //             </div>
                        //         </div>
                        //         <div className="relieve-question">
                        //             <div className="relieve-question2">
                        //                 3) How did you reach to the conclusion of quitting this job?
                        //             </div>
                        //             <div className="relieve-question2">
                        //                 <textarea
                        //                     autoFocus
                        //                     className="input-wrap width-30 margin0 textarea-relieve exit-wrap"
                        //                     id="filled-multiline-static"
                        //                     rows={4}
                        //                     variant="filled"
                        //                     label="Description"
                        //                     defaultValue=""
                        //                     onChange={this.textareaOnchange}
                        //                 />
                        //             </div>
                        //         </div>
                        //         <div className="relieve-question">
                        //             <div className="relieve-question2">
                        //                 4) At your service, is there any moment you really enjoyed or felt proud?
                        //             </div>
                        //             <div className="relieve-question2">
                        //                 <textarea
                        //                     autoFocus
                        //                     className="input-wrap width-30 margin0 textarea-relieve exit-wrap"
                        //                     id="filled-multiline-static"
                        //                     rows={4}
                        //                     variant="filled"
                        //                     label="Description"
                        //                     defaultValue=""
                        //                     onChange={this.textareaOnchange}
                        //                 />
                        //             </div>
                        //         </div>
                        //         <div className="relieve-question">
                        //             <div className="relieve-question2">
                        //                 5) Did the company become supportive in meeting your career goal?
                        //             </div>
                        //             <div className="relieve-question2">
                        //                 <textarea
                        //                     autoFocus
                        //                     className="input-wrap width-30 margin0 textarea-relieve exit-wrap"
                        //                     id="filled-multiline-static"
                        //                     rows={4}
                        //                     variant="filled"
                        //                     label="Description"
                        //                     defaultValue=""
                        //                     onChange={this.textareaOnchange}
                        //                 />
                        //             </div>
                        //         </div>
                        //     </div>
                        // }
                        if (item.type == "cbText") {
                            return <div class="table-wrapper clear-both">
                                <div class="remove-last-child-table exits-table-wrap">
                                    <table class="zq-table-wrap" id="table-to-xls">
                                        <thead class="zq-table-heading">
                                            <tr>
                                                <th>
                                                    <span>Department</span>
                                                </th>
                                                <th>
                                                    <span>Dues from Employee (₹)</span>
                                                </th>
                                                <th>
                                                    <span>Dues to Pay Employee (₹)</span>
                                                </th>
                                                <th>
                                                    <span>Status</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody class="zq-table-body">
                                            <tr>
                                                <td><span>Library</span></td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.Duesempfrom != undefined ? item.defaultValue.librarianDataInformation.Duesempfrom : null : null : null}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "libraryDueToCollect", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.Duesempto != undefined ? item.defaultValue.librarianDataInformation.Duesempto : null : null : null}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "libraryDueToPay", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className={item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.status != undefined ? item.defaultValue.librarianDataInformation.status == "Completed" ? "Status-Done" : "Status-Pending" : "Status-Pending" : "Status-Pending" : "Status-Created"}><span>{item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.status != undefined ? item.defaultValue.librarianDataInformation.status : "Created" : "Created" : "Created"}</span></td>
                                                {/* <td className={localStorage.getItem("libraryStatus") == undefined ? "Status-Created" : localStorage.getItem("libraryStatus") == "Done" ? "Status-Done" : "Status-Pending"}>{localStorage.getItem("libraryStatus") == undefined ? <span>Created</span> : localStorage.getItem("libraryStatus") == "Done" ? <span>Done</span> : <span>Pending</span>}</td> */}
                                            </tr>

                                            <tr>
                                                <td><span>Lab</span></td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom2 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom2) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom3 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom3) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom4 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom4) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom5 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom5) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom6 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom6) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom7 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom7) : null : null : null)}

                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "labDueToCollect", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto2 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto2) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto3 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto3) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto4 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto4) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto5 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto5) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto6 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto6) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto7 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto7) : null : null : null)}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "labDueToPay", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className={item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.status != undefined ? item.defaultValue.labDataInformation.status == "Completed" ? "Status-Done" : "Status-Pending" : "Status-Pending" : "Status-Pending" : "Status-Created"}><span>{item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.status != undefined ? item.defaultValue.labDataInformation.status : "Created" : "Created" : "Created"}</span></td>

                                            </tr>


                                            <tr>
                                                <td><span>Office</span></td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.officeDuesempfrom != undefined ? item.defaultValue.officeDataInformation.officeDuesempfrom : null : null : null}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "officeDueToCollect", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.officeDuesempto != undefined ? item.defaultValue.officeDataInformation.officeDuesempto : null : null : null}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "officeDueToPay", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className={item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.status != undefined ? item.defaultValue.officeDataInformation.status == "Completed" ? "Status-Done" : "Status-Pending" : "Status-Pending" : "Status-Pending" : "Status-Created"}><span>{item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.status != undefined ? item.defaultValue.officeDataInformation.status : "Created" : "Created" : "Created"}</span></td>
                                                {/* <td className={localStorage.getItem("officeStatus") == undefined ? "Status-Created" : localStorage.getItem("officeStatus") == "Done" ? "Status-Done" : "Status-Pending"}>{localStorage.getItem("officeStatus") == undefined ? <span>Created</span> : localStorage.getItem("officeStatus") == "Done" ? <span>Done</span> : <span>Pending</span>}</td> */}
                                            </tr>


                                            <tr>
                                                <td className="clearance-total"><span>Total</span></td>
                                                <td className="clearance-total2">
                                                    {this.formatCurrency(Number(item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.Duesempfrom != undefined ? Number(item.defaultValue.librarianDataInformation.Duesempfrom) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom2 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom2) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom3 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom3) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom4 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom4) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom5 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom5) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom6 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom6) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom7 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom7) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.officeDuesempfrom != undefined ? Number(item.defaultValue.officeDataInformation.officeDuesempfrom) : 0 : 0 : 0))}

                                                </td>
                                                <td className="clearance-total2">
                                                    {this.formatCurrency(Number(item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.Duesempto != undefined ? Number(item.defaultValue.librarianDataInformation.Duesempto) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto2 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto2) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto3 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto3) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto4 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto4) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto5 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto5) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto6 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto6) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto7 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto7) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.officeDuesempto != undefined ? Number(item.defaultValue.officeDataInformation.officeDuesempto) : 0 : 0 : 0))}
                                                    {/* <TextField
                                                        defaultValue={Number(item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.Duesempto != undefined ? Number(item.defaultValue.librarianDataInformation.Duesempto) : 0 : 0 : 0) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto2 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto2) : 0 : 0 : 0) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.officeDuesempto != undefined ? Number(item.defaultValue.officeDataInformation.officeDuesempto) : 0 : 0 : 0)}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "financeDueTopay", item) }}
                                                    >
                                                    </TextField> */}
                                                </td>

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }

                        // if (item.category == "recaptcha") {
                        //     return <ZenRecaptcha inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        // }
                        if (item.category == 'button' && item.type == 'submit') {
                            return <ButtonField inputData={item} inputIndex={index} />
                        }
                    })}
                </form> : null
                }
                {
                    this.state.formData.length > 0 ? <React.Fragment>
                        {this.state.formData.map((item, index) => {
                            if (item.category == 'button' && item.type != 'submit') {
                                return <Button disableRipple={true} type={item.type} class={item.class} onClick={() => this.onFormBtnEvent(item)}>{item.label}</Button>
                            }
                        })}
                    </React.Fragment> : null
                }
            </React.Fragment >
        )
    }
}
export default ZenForm;